<div class="layout-content">
	<!-- per aumentare la dimensione delle stelle .custom-rate .p-rating-icon {
		margin-top: 30px;
		font-size: 50px;
	}-->
	<div *ngIf="ratingLoading">
		<div class="flex align-items-center justify-content-center w-full pb-8 mb-8">
			<p-progressSpinner ariaLabel="loading"></p-progressSpinner>
		</div>
	</div>
	<form (ngSubmit)="submit()" [formGroup]="ratingForm" *ngIf="!ratingLoading">
		<div class="grid gap-3">
			<div class="col-12 text-lg flex justify-content-center align-items-center text-center">
				{{ 'RATING_DIALOG_WARNING'| translate }}
			</div>
			<div class="col-12 flex justify-content-center align-items-center">
				<p-rating formControlName="ratingValue" [cancel]="false" />
			</div>
			<div class="col-12 flex justify-content-center align-items-center">
				<textarea rows="8" cols="60" pInputTextarea formControlName="text" [maxLength]="500" placeholder="{{'RATING_DIALOG_TEXT' | translate }}
{{'FIELD_NOT_REQUIRED' | translate }}"> <!-- !! non spostare questa inner line -> provoca spostamento string placehoder nella textarea -->
				</textarea>
			</div>
		</div>

		<div class="grid mt-5 flex justify-content-center align-items-center">
			<button type="submit" pButton pRipple label="{{ 'CONFIRM' | translate }}" [disabled]="f.ratingValue.value<=0"
				class="p-button-primary text-xl font-normal mx-2 my-1" [ngClass]="dynamicButtonWidth()">
			</button>
			<!-- <button type="button" pButton pRipple (click)="goToForm()" label="{{ 'GO_TO_FORM' | translate }}"
				class="p-button-primary text-xl font-normal mx-2 my-1" [ngClass]="dynamicButtonWidth()">
			</button> -->
			<button type="button" pButton pRipple (click)="closeAndRememberAfter()" label="{{ 'REMEMBER_IN_FUTURE' | translate }}"
				class="p-button-secondary text-xl font-normal mx-2 my-1" [ngClass]="dynamicButtonWidth()">
			</button>
		</div>
	</form>
</div>